import React, { useEffect, useState } from 'react';
import { IoHandRightOutline } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { IoIosStar } from 'react-icons/io';
import Layout from '../../components/global/layout';
import loader from '../../methods/loader';
import ApiClient from '../../methods/api/apiClient';
import { Routes } from '../../methods/ApiRoutes';
import { useNavigate } from 'react-router-dom';
import CommonGraph from '../../components/Charts/CommonGraph';
import methodModel from '../../methods/methods';
import { Tooltip } from 'antd';
import { FaEdit, FaEye } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { FiGift, FiArrowUpRight } from 'react-icons/fi';
import moment from 'moment';
import DateRangePicker from '../../components/Charts/DateRangePicker';

function Dashboard() {
  const user = useSelector((state) => state.user);
  const [DateFilters, setDateFilters] = useState({
    startDate: moment().subtract(30, 'days').toDate(),
    endDate: moment().toDate(),
    key: 'selection'
  });
  const Navigate = useNavigate();
  const [cards, setCards] = useState([]);
  const [topResellers, setTopResellers] = useState([]);
  const [DashboardData, setDashboardData] = useState({});
  const [recentActivity, setRecentActivity] = useState([]);
  const [isDashboardLoading, setIsDashboardLoading] = useState(false);
  const [isRegistrationLoading, setIsRegistrationLoading] = useState(false);
  const [isRedemptionLoading, setIsRedemptionLoading] = useState(false);
  const GetDashboarData = () => {
    setIsDashboardLoading(true);
    ApiClient.get(`dashboard/admin`).then(res => {
      if (res.success) {
        console.log(res, "dashboard data")
        setRecentActivity(res?.data?.recentActivity || []);
        setDashboardData(res?.data)
        const data = res?.data;
        setCards([
          {
            title: 'Total Users',
            value: data?.totalUsers,
            route: `/${Routes.User?.url}`,
            permission: Routes.User.permissionKey,
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" className='min-w-[100px] w-[100px] h-[80px]' viewBox="0 0 72 72" fill="none">
                <path d="M25.7152 36C28.2585 36 30.7447 35.2458 32.8594 33.8327C34.974 32.4197 36.6222 30.4113 37.5953 28.0615C38.5685 25.7118 38.823 23.1262 38.3267 20.6318C37.8304 18.1374 36.6055 15.8462 34.8069 14.0479C33.0084 12.2497 30.7169 11.0252 28.2224 10.5293C25.7279 10.0334 23.1424 10.2883 20.7928 11.2619C18.4432 12.2355 16.4351 13.884 15.0224 15.9989C13.6098 18.1138 12.856 20.6002 12.8564 23.1435C12.86 26.5525 14.216 29.8209 16.6268 32.2312C19.0375 34.6416 22.3061 35.997 25.7152 36Z" fill="#CC9900" />
                <path d="M42.5362 46.6222C39.2778 43.28 35.0971 40.985 30.5281 40.0303C25.9591 39.0757 21.2092 39.5047 16.8852 41.2625C12.5611 43.0204 8.85927 46.0273 6.25243 49.8992C3.64558 53.7712 2.25211 58.3323 2.25 63C2.25 63.5967 2.48705 64.169 2.90901 64.5909C3.33097 65.0129 3.90326 65.25 4.5 65.25H46.935C47.5317 65.25 48.104 65.0129 48.526 64.5909C48.9479 64.169 49.185 63.5967 49.185 63C49.1937 60.6141 48.8254 58.2419 48.0937 55.971C47.0043 52.4601 45.1 49.2567 42.5362 46.6222Z" fill="#CC9900" />
                <path d="M52.875 37.125C58.1562 37.125 62.4375 32.8437 62.4375 27.5625C62.4375 22.2813 58.1562 18 52.875 18C47.5938 18 43.3125 22.2813 43.3125 27.5625C43.3125 32.8437 47.5938 37.125 52.875 37.125Z" fill="#CC9900" />
                <path d="M52.875 39.7574C49.859 39.7688 46.9014 40.5902 44.3115 42.1357C44.7998 42.5722 45.2925 43.0019 45.7538 43.4744C48.8174 46.6234 51.0933 50.452 52.3958 54.6479C52.8418 56.0293 53.1708 57.4458 53.379 58.8824H67.5C68.0968 58.8824 68.669 58.6454 69.091 58.2234C69.513 57.8015 69.75 57.2292 69.75 56.6324C69.7452 52.1584 67.9658 47.8689 64.8022 44.7053C61.6385 41.5416 57.3491 39.7622 52.875 39.7574Z" fill="#CC9900" />
              </svg>
            ),
          },
          {
            title: 'Total Staff',
            value: data?.totalSubAdmin,
            route: `/${Routes.Staff?.url}`,
            permission: Routes.Staff.permissionKey,
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" className='min-w-[100px] w-[100px] h-[80px]' viewBox="0 0 88 88" fill="none">
                <path d="M40.6587 43.8212C48.2493 46.0781 56.4803 40.0617 56.361 31.9273C55.6843 15.5485 32.3148 15.5494 31.6387 31.9275C31.6387 37.5786 35.4612 42.3637 40.6587 43.8212Z" fill="#CC9900" />
                <path d="M63.9241 63.6212C62.3016 54.1062 53.9829 46.8462 44.0004 46.8462C32.7256 46.7632 23.287 56.4745 23.8565 67.4987C24.0354 68.0487 24.5579 68.42 25.1491 68.42H62.8517C65.1199 68.2287 63.998 65.0636 63.9241 63.6212Z" fill="#CC9900" />
                <path d="M67.9937 47.9187C72.9712 47.9187 77.0275 43.8624 77.0275 38.8849C76.574 26.9353 59.4116 26.9386 58.96 38.885C58.96 43.8624 63.0162 47.9187 67.9937 47.9187Z" fill="#CC9900" />
                <path d="M67.9935 48.8812C65.4361 48.8812 62.906 49.555 60.7061 50.8337C61.3523 51.5074 61.9435 52.2362 62.4935 52.9925C64.9739 56.3395 66.5229 60.499 66.8247 64.7487H81.1248C81.881 64.7487 82.4998 64.13 82.4998 63.3737C82.4998 55.3849 75.9961 48.8812 67.9935 48.8812Z" fill="#CC9900" />
                <path d="M20.0064 47.9187C24.9839 47.9187 29.0402 43.8624 29.0402 38.8849C28.5867 26.9353 11.4243 26.9386 10.9727 38.885C10.9727 43.8624 15.0289 47.9187 20.0064 47.9187Z" fill="#CC9900" />
                <path d="M27.2939 50.8337C17.9182 45.181 5.30461 52.4082 5.5003 63.3739C5.50013 64.13 6.11889 64.7487 6.87513 64.7487H21.1752C21.5469 59.5305 23.7601 54.5784 27.2939 50.8337Z" fill="#CC9900" />
              </svg>
            ),
          },
          {
            title: 'Total Venues',
            value: data?.totalVenues,
            route: `/${Routes.Venue.url}`,
            permission: Routes.Venue.permissionKey,
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" className='min-w-[100px] w-[100px] h-[80px]' viewBox="0 0 58 58" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2729 41.7762H21.5161L29.0004 52.6272L36.4847 41.7762H44.7279L50.6824 57.0938H7.31836L13.2729 41.7762ZM29.0004 0.90625C24.289 0.9064 19.7707 2.77804 16.4392 6.10946C13.1078 9.44088 11.2361 13.9592 11.236 18.6706C11.236 26.3112 16.7761 31.7126 20.8557 37.6264L29.0004 49.4349L37.1453 37.6264C41.2249 31.7131 46.765 26.3109 46.765 18.6706C46.7649 13.9592 44.8932 9.4408 41.5617 6.10938C38.2302 2.77795 33.7118 0.90634 29.0004 0.90625ZM29.0004 10.1818C30.6017 10.1818 32.167 10.6566 33.4984 11.5462C34.8299 12.4359 35.8676 13.7003 36.4804 15.1797C37.0932 16.6591 37.2535 18.287 36.9412 19.8575C36.6288 21.428 35.8577 22.8706 34.7254 24.0029C33.5931 25.1352 32.1505 25.9063 30.58 26.2187C29.0094 26.5311 27.3816 26.3707 25.9022 25.7579C24.4228 25.1451 23.1583 24.1074 22.2687 22.776C21.3791 21.4446 20.9043 19.8792 20.9043 18.2779C20.9043 16.1307 21.7573 14.0714 23.2756 12.5531C24.7939 11.0348 26.8532 10.1818 29.0004 10.1818Z" fill="#CC9900" />
              </svg>
            ),
          },
          {
            title: 'Active Venues',
            value: data?.totalActiveVenues,
            route: `/${Routes.Venue.url}?status=active`,
            permission: Routes.Venue.permissionKey,
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" className='min-w-[100px] w-[100px] h-[80px]' viewBox="0 0 72 72" fill="none">
                <path d="M42.2227 48.2793C44.5787 44.6486 46.2765 40.823 46.6588 36.6682C46.6612 36.6418 46.6696 36.6198 46.6856 36.5986L50.5233 31.4831C50.5501 31.4476 50.5883 31.4284 50.6328 31.4284C50.6773 31.4284 50.7156 31.4476 50.7422 31.4831L63.3334 48.2717C63.3652 48.3142 63.3701 48.3674 63.3464 48.415C63.3226 48.4625 63.2771 48.4907 63.224 48.4907H42.3375C42.2859 48.4907 42.2417 48.4643 42.2173 48.4191C42.1926 48.3738 42.1946 48.3225 42.2227 48.2793ZM35.761 12.2282C36.215 12.49 36.802 12.3405 37.0697 11.877L39.4136 7.81703C39.6777 7.35983 39.522 6.77346 39.0632 6.50836C38.6044 6.24326 38.0188 6.40151 37.7547 6.85871L35.4091 10.9186C35.1448 11.3776 35.3022 11.9639 35.761 12.2282ZM68.7146 68.4858C68.7146 69.0529 68.2548 69.5127 67.6877 69.5127H4.6717C4.10463 69.5127 3.64484 69.0529 3.64484 68.4858C3.64484 67.9187 4.10463 67.4591 4.6717 67.4591H23.7379C23.7904 67.4591 23.8355 67.4316 23.8596 67.3848C23.8836 67.3381 23.8799 67.2854 23.8493 67.2427C21.6389 64.1449 18.9358 61.091 16.3101 58.1239C9.90697 50.8884 3.28613 43.4062 3.28613 34.8952C3.28613 23.4432 12.6038 14.1265 24.0557 14.1265C35.5076 14.1265 44.8244 23.4433 44.8244 34.8952C44.8244 43.5826 38.1596 51.0192 31.715 58.2124C29.0859 61.1466 26.3784 64.1683 24.1658 67.2422C24.135 67.285 24.1311 67.3377 24.1552 67.3847C24.1792 67.4314 24.2243 67.4591 24.277 67.4591H40.9414C41.0169 67.4591 41.0784 67.3976 41.0784 67.3223V50.5449C41.0784 50.4694 41.1398 50.4081 41.2152 50.4081H60.0488C60.1242 50.4081 60.1856 50.4695 60.1856 50.5449V67.3222C60.1856 67.3976 60.2471 67.459 60.3225 67.459H67.6877C68.2549 67.4591 68.7146 67.9189 68.7146 68.4858ZM24.0555 45.5748C29.4397 45.5748 33.8193 41.1939 33.8193 35.8098C33.8193 30.4255 29.4397 26.0459 24.0555 26.0459C18.6714 26.0459 14.2905 30.4255 14.2905 35.8098C14.2903 41.1939 18.6712 45.5748 24.0555 45.5748ZM55.5326 57.9905C55.5326 57.4613 55.1045 57.0322 54.5743 57.0322H46.6896C46.1613 57.0322 45.7313 57.4612 45.7313 57.9905V67.3223C45.7313 67.3978 45.7928 67.4591 45.8681 67.4591H47.5117C47.5872 67.4591 47.6485 67.3976 47.6485 67.3223V59.0856C47.6485 59.0102 47.71 58.9487 47.7854 58.9487H53.4791C53.5545 58.9487 53.6159 59.0102 53.6159 59.0856V67.3223C53.6159 67.3978 53.6774 67.4591 53.7528 67.4591H55.3956C55.471 67.4591 55.5324 67.3976 55.5324 67.3223V57.9905H55.5326ZM24.0557 9.09158C24.584 9.09158 25.014 8.66332 25.014 8.13326V3.44562C25.014 2.91556 24.5842 2.4873 24.0557 2.4873C23.5256 2.4873 23.0974 2.91556 23.0974 3.44562V8.1334C23.0974 8.66347 23.5256 9.09158 24.0557 9.09158ZM11.0417 11.877C11.2198 12.1851 11.5412 12.3565 11.8724 12.3565C12.5982 12.3565 13.0744 11.5651 12.7006 10.9186L10.3575 6.85871C10.0934 6.40151 9.50693 6.24326 9.04815 6.50836C8.59009 6.77332 8.43183 7.35983 8.6978 7.81703L11.0417 11.877Z" fill="#CC9900" />
              </svg>
            ),
          },
        ]);
      }
      setIsDashboardLoading(false);
    }).catch(() => {
      setIsDashboardLoading(false);
    });
  }
  useEffect(() => {
    GetDashboarData();
  }, [])

  useEffect(() => {
    GetRegistration();
    GetRedemption();
  }, [DateFilters])

  const [RegistrationData, setRegistrationData] = useState([]);
  const GetRegistration = () => {
    let params = {
      startDate: moment(DateFilters.startDate).format('YYYY-MM-DD'),
      endDate: moment(DateFilters.endDate).format('YYYY-MM-DD')
    }
    setIsRegistrationLoading(true);
    ApiClient.get('dashboard/registrations/graph', params).then((res) => {
      if (res.success) {
        console.log(res?.data, "Registration Data ----")
        setRegistrationData(res?.data || []);
      }
      setIsRegistrationLoading(false);
    }).catch(() => {
      setIsRegistrationLoading(false);
    });
  };

  const [RedemptionData, setRedemptionData] = useState([]);
  const GetRedemption = () => {
    let params = {
      startDate: moment(DateFilters.startDate).format('YYYY-MM-DD'),
      endDate: moment(DateFilters.endDate).format('YYYY-MM-DD')
    }
    setIsRedemptionLoading(true);
    ApiClient.get('dashboard/transactions/graph', params).then((res) => {
      if (res.success) {
        console.log(res?.data, "Redemption Data ----")
        setRedemptionData(res?.data || []);
      }
      setIsRedemptionLoading(false);
    }).catch(() => {
      setIsRedemptionLoading(false);
    });
  };
  return (
    <Layout>
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
        <div>
          <div className="flex items-center gap-2.5">
            <div className="p-2 bg-[#CC9900]/10 rounded-2xl">
              <IoHandRightOutline className="text-2xl text-[#CC9900] animate-bounce" style={{ animationDuration: '2.5s' }} />
            </div>
            <h1 className="text-2xl font-extrabold text-gray-900 tracking-tight">
              Welcome back, <span className="text-[#CC9900]">{user?.fullName || 'Admin'}</span>
            </h1>
          </div>
          <p className="text-xs text-gray-500 mt-1 font-medium md:ml-12">
            Here's what's happening across your venues today.
          </p>
        </div>

        {/* Global Date Filter */}
        <div className="flex items-center gap-3">
          <DateRangePicker
            ranges={DateFilters}
            onChange={(range) => setDateFilters({ ...range, key: 'selection' })}
          />
        </div>
      </div>

      <main className="space-y-6">
        {/* Top Cards */}
        <section className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
          {isDashboardLoading || cards.length === 0 ? (
            Array.from({ length: 4 }).map((_, idx) => (
              <div key={idx} className="flex items-center gap-5 p-6 rounded-[24px] bg-white border border-gray-100 shadow-[0_4px_20px_-2px_rgba(0,0,0,0.02)]">
                <div className="w-12 h-12 rounded-2xl skeleton shrink-0" />
                <div className="space-y-2 w-full">
                  <div className="h-6 w-1/3 skeleton" />
                  <div className="h-3.5 w-1/2 skeleton" />
                </div>
              </div>
            ))
          ) : (
            cards.map((card, index) =>
              !methodModel.hasPermission(user, card?.permission, "read") ? null : (
                <div
                  key={index}
                  onClick={() => Navigate(card?.route)}
                  className={`group relative overflow-hidden flex items-center gap-5 p-6 rounded-[24px] bg-white border border-gray-100 shadow-[0px_1px_3px_rgba(16,24,40,0.1),0px_1px_2px_rgba(16,24,40,0.06)] hover:shadow-[0px_12px_24px_-4px_rgba(204,153,0,0.12),0px_4px_8px_-2px_rgba(204,153,0,0.04)] hover:-translate-y-1 transition-all duration-300 border-l-[4px] ${
                    index % 4 === 0 ? 'border-l-amber-500' :
                    index % 4 === 1 ? 'border-l-indigo-500' :
                    index % 4 === 2 ? 'border-l-emerald-500' : 'border-l-violet-500'
                  } ${card?.route ? "cursor-pointer" : ""}`}
                >
                  {/* Visual Accent Gradient Ring */}
                  <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-[#CC9900]/10 to-[#CC9900]/0 rounded-full translate-x-6 -translate-y-6 group-hover:scale-125 transition-transform duration-500 pointer-events-none" />

                  {/* Icon circle */}
                  <div className={`flex-shrink-0 p-2.5 rounded-2xl transition-all duration-300 flex items-center justify-center ${
                    index % 4 === 0 ? 'bg-amber-50 text-amber-600 border border-amber-100 group-hover:bg-amber-100' :
                    index % 4 === 1 ? 'bg-indigo-50 text-indigo-600 border border-indigo-100 group-hover:bg-indigo-100' :
                    index % 4 === 2 ? 'bg-emerald-50 text-emerald-600 border border-emerald-100 group-hover:bg-emerald-100' :
                    'bg-violet-50 text-violet-600 border border-violet-100 group-hover:bg-violet-100'
                  }`}>
                    <div className="w-12 h-12 flex items-center justify-center">
                      {React.cloneElement(card.icon, {
                        className: `w-10 h-10 object-contain min-w-0 transition-transform duration-300 group-hover:scale-110 ${
                          index % 4 === 0 ? 'text-amber-600' :
                          index % 4 === 1 ? 'text-indigo-600' :
                          index % 4 === 2 ? 'text-emerald-600' : 'text-violet-600'
                        }`
                      })}
                    </div>
                  </div>
                  <div>
                    <h3 className="text-3xl font-extrabold text-[#111827] tracking-tight transition-colors duration-200">
                      {card.value?.toLocaleString() || card.value}
                    </h3>
                    <p className="text-sm font-semibold text-[#667085] mt-1 tracking-tight">{card.title}</p>
                  </div>

                </div>
              )
            )
          )}
        </section>

        {/* Registration Section */}
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <CommonGraph
            data={RegistrationData}
            title="User Registration Trends"
            dataKeys={['users']}
            loading={isRegistrationLoading}
          />

          <CommonGraph
            data={RegistrationData}
            title="Venue Registration Trends"
            dataKeys={['venues']}
            loading={isRegistrationLoading}
          />
        </section>

        {/* Transaction & Points Insights Section */}
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <CommonGraph
            data={RedemptionData}
            title="Points Overview (Earned vs Redeemed)"
            dataKeys={['totalPointsEarned', 'totalPointsRedeemed']}
            loading={isRedemptionLoading}
          />

          <CommonGraph
            data={RedemptionData}
            title="Transaction Volume"
            dataKeys={['totalTransactions']}
            loading={isRedemptionLoading}
          />
        </section>


        {/* Recent Activity Section */}
        <section>
          <div className="bg-white border border-gray-200/70 rounded-[24px] shadow-[0px_1px_3px_rgba(16,24,40,0.04)] overflow-hidden">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200/70">
              <div>
                <h2 className="text-[#101828] font-bold text-base tracking-tight">Recent Activity</h2>
                <p className="text-[#667085] text-[10px] font-semibold uppercase tracking-wider mt-0.5">Transaction Ledger</p>
              </div>
              <button
                onClick={() => Navigate('/transaction')}
                className="text-xs font-bold text-[#CC9900] hover:text-[#B38000] transition-colors bg-[#F9FAFB] hover:bg-[#F2F4F7] px-3.5 py-1.5 rounded-xl border border-[#EAECF0]"
              >
                View Full History
              </button>
            </div>

            {isDashboardLoading ? (
              <div className="divide-y divide-gray-200/60">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <div key={idx} className="flex items-center justify-between px-6 py-4.5">
                    <div className="flex items-start gap-4 w-full">
                      <div className="w-8 h-8 rounded-full skeleton shrink-0" />
                      <div className="space-y-2 w-full">
                        <div className="h-3 w-1/4 skeleton" />
                        <div className="h-2.5 w-1/2 skeleton" />
                      </div>
                    </div>
                    <div className="flex flex-col items-end gap-1.5 shrink-0">
                      <div className="h-6 w-16 rounded-full skeleton" />
                      <div className="h-2.5 w-12 skeleton" />
                    </div>
                  </div>
                ))}
              </div>
            ) : recentActivity && recentActivity.length > 0 ? (
              <div className="divide-y divide-gray-200/60">
                {recentActivity.slice(0, 10).map((item, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between px-6 py-4 hover:bg-[#F9FAFB]/50 transition-colors"
                  >
                    <div className="flex items-center gap-4">
                      {/* Icon circle */}
                      <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 border transition-all duration-300 ${
                        item.type === 'redeemed'
                          ? 'bg-rose-50/50 border-rose-200 text-rose-500'
                          : 'bg-emerald-50/50 border-emerald-200 text-emerald-500'
                      }`}>
                        {item.type === 'redeemed' ? (
                          <FiGift className="w-4 h-4" />
                        ) : (
                          <FiArrowUpRight className="w-4 h-4" />
                        )}
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-gray-900 leading-tight">
                          {item?.notes || item?.discription || (item.type === 'redeemed' ? 'Reward Redeemed' : 'Points Credited')}
                        </p>
                        <p className="text-[11px] text-gray-400 mt-1 font-medium">
                          {moment(item.updatedAt || item.createdAt).fromNow()}
                        </p>
                      </div>
                    </div>
                    <div className="text-right flex items-center gap-3">
                      <span className={`text-[15px] font-bold tracking-tight ${
                        item.type === 'redeemed' ? 'text-rose-600' : 'text-emerald-600'
                      }`}>
                        {item.type === 'redeemed' ? '-' : '+'}{item?.points || item?.creditPoints || item?.redeemPoints || 0} pts
                      </span>
                      <span className={`inline-flex items-center justify-center px-2.5 py-0.5 rounded-full text-[10px] font-bold border capitalize tracking-wide ${
                        item.type === 'redeemed'
                          ? 'bg-rose-50 text-rose-700 border-rose-200'
                          : 'bg-emerald-50 text-emerald-700 border-emerald-200'
                      }`}>
                        {item.type}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="p-8 text-center text-gray-400 text-sm">
                No recent activity found
              </div>
            )}
          </div>
        </section>
      </main>
    </Layout>
  );
}

export default Dashboard;
